import { render, staticRenderFns } from "./notification-modal.vue?vue&type=template&id=a145c258&scoped=true"
import script from "./notification-modal.vue?vue&type=script&lang=js"
export * from "./notification-modal.vue?vue&type=script&lang=js"
import style0 from "./notification-modal.vue?vue&type=style&index=0&id=a145c258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a145c258",
  null
  
)

export default component.exports